module.exports = "<header class=\"header\">\n  <nav class=\"inner\">\n    <a routerLink=\"/\">V2EX</a>\n    <a routerLink=\"/topics/hot\" routerLinkActive=\"active\">Hot</a>\n    <a routerLink=\"/topics/latest\" routerLinkActive=\"active\">Latest</a>\n    <a href=\"https://github.com/sinchang/angular-v2ex\" target=\"_blank\" rel=\"noopener\" class=\"github\">Built with Angular 4</a>\n  </nav>\n</header>\n<div class=\"news-view view\">\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 163
// module chunks = 1